export default __webpack_public_path__ + "static/media/AdobeStock_74901983.18090732.jpg";